import { useEffect, useState } from "react";
import { Card, Button, Flex } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import Cash from "./Cash";
import EWallet from "./EWallet";

export default function PaymentCard(props) {
  const {
    plates,
    setIsShowPayment,
    onPaymentSuccessReset,
    setIsDisableButton,
    receiptPrice,
    setReceiptPrice,
    itemDetailsCardRef,
    setExtraChargesOptions,
    connectDevice,
    setConnectDevice,
  } = props;

  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState();
  const [scannerResult, setScannerResult] = useState();
  const [
    isDisplayChangePaymentMethodButton,
    setIsDisplayChangePaymentMethodButton,
  ] = useState("none");

  const [isDisableCancelPaymentButton, setIsDisableCancelPaymentButton] =
    useState(false);
  const [paymentStage, setPaymentStage] = useState();
  const [transactionInfo, setTransactionInfo] = useState();

  const onCancelPaymentButtonClicked = () => {
    setIsDisableButton((prev) =>
      Object.fromEntries(Object.keys(prev).map((key) => [key, false]))
    );
    resetPaymentPriceMethod(false);
  };

  const onChangePaymentMethodButtonClicked = () => {
    resetPaymentPriceMethod(true);
  };

  const resetPaymentPriceMethod = (showPayment) => {
    setIsShowPayment(showPayment);
    setSelectedPaymentMethod(null);
    setReceiptPrice((prev) => ({
      ...prev,
      total: receiptPrice.subtotal + receiptPrice.sst,
      change: null,
      round_adj: null,
      cash: null,
    }));
  };

  function onPaymentMethodSelected(method) {
    if (method == "E-Wallet") {
      setPaymentStage("scan");
      setScannerResult(null);
    }
    setSelectedPaymentMethod(method);
    setIsDisableButton((prev) => ({ ...prev, pay_btn: true }));
  }

  const PAYMENT_METHOD = {
    Cash: (
      <Cash
        plates={plates}
        onPaymentSuccessReset={onPaymentSuccessReset}
        receiptPrice={receiptPrice}
        setReceiptPrice={setReceiptPrice}
        transactionInfo={transactionInfo}
        setTransactionInfo={setTransactionInfo}
        setExtraChargesOptions={setExtraChargesOptions}
        connectDevice={connectDevice}
        setConnectDevice={setConnectDevice}
      />
    ),
    // "E-Wallet": (
    //   <EWallet
    //     plates={plates}
    //     onPaymentSuccessReset={onPaymentSuccessReset}
    //     scannerResult={scannerResult}
    //     setScannerResult={setScannerResult}
    //     setIsDisableCancelPaymentButton={setIsDisableCancelPaymentButton}
    //     setIsDisplayChangePaymentMethodButton={
    //       setIsDisplayChangePaymentMethodButton
    //     }
    //     paymentStage={paymentStage}
    //     setPaymentStage={setPaymentStage}
    //     receiptPrice={receiptPrice}
    //     transactionInfo={transactionInfo}
    //     setTransactionInfo={setTransactionInfo}
    //     connectDevice={connectDevice}
    //     setConnectDevice={setConnectDevice}
    //   />
    // ),
  };

  useEffect(() => {
    if (selectedPaymentMethod && selectedPaymentMethod == "Cash") {
      setIsDisplayChangePaymentMethodButton("unset");
    } else if (
      selectedPaymentMethod &&
      selectedPaymentMethod == "E-Wallet" &&
      scannerResult == null
    ) {
      setIsDisplayChangePaymentMethodButton("unset");
    } else {
      setIsDisplayChangePaymentMethodButton("none");
    }
  }, [selectedPaymentMethod, scannerResult]);

  useEffect(() => {
    if (selectedPaymentMethod != null) {
      setIsDisableButton((prev) => ({ ...prev, cancel_order_btn: true }));
    } else {
      setIsDisableButton((prev) => ({ ...prev, cancel_order_btn: false }));
    }
  }, [selectedPaymentMethod]);

  useEffect(() => {
    if (scannerResult) {
      setIsDisableCancelPaymentButton(true);
    } else {
      setIsDisableCancelPaymentButton(false);
    }
  }, [scannerResult]);

  return (
    <div ref={itemDetailsCardRef} style={{ height: "100%", width: "100%" }}>
      <Card
        style={{ height: "100%" }}
        styles={{ body: { height: "calc(100% - 56px)", padding: 10 } }}
        title={
          <Button
            type="primary"
            danger
            icon={<CloseCircleOutlined />}
            onClick={onCancelPaymentButtonClicked}
            disabled={isDisableCancelPaymentButton}
            style={{ fontWeight: "bold" }}
          >
            Cancel Payment
          </Button>
        }
        extra={
          <Button
            type="primary"
            onClick={onChangePaymentMethodButtonClicked}
            style={{
              fontWeight: "bold",
              display: isDisplayChangePaymentMethodButton,
            }}
          >
            Change Payment Method
          </Button>
        }
      >
        <div style={{ height: "100%", width: "100%" }}>
          {selectedPaymentMethod ? (
            PAYMENT_METHOD[selectedPaymentMethod]
          ) : (
            <Flex
              wrap
              style={{ height: "100%", width: "100%" }}
              justify="space-evenly"
              align="center"
            >
              {Object.keys(PAYMENT_METHOD).map((key) => {
                return (
                  <Button
                    className="payment-method-btn"
                    onClick={() => {
                      onPaymentMethodSelected(key);
                    }}
                  >
                    {key}
                  </Button>
                );
              })}
            </Flex>
          )}
        </div>
      </Card>
    </div>
  );
}
